import Image from 'next/image';
import { SVGProps } from 'react';

const SVGHoodie = ({ width = '228px', height = '136px' }: SVGProps<SVGElement>) => {
  return <Image src="/svgs/hoodie.svg" alt="Hoodie" width={width} height={height} />;
};

export default SVGHoodie;
